import {
  Directive,
  Inject,
  Injector,
  Input,
  TemplateRef,
  ViewContainerRef,
} from "@angular/core";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { AuthService } from "src/app/core/services";

// TODO: Add Angular decorator.
@Directive()
class ChannelPermission {
  templateRef: TemplateRef<any>;
  viewContainerRef: ViewContainerRef;
  authService: AuthService;
  protected destroyed$ = new Subject<void>();

  channelPermission: number[] = [];

  constructor(injector: Injector) {
    this.templateRef = injector.get(TemplateRef);
    this.viewContainerRef = injector.get(ViewContainerRef);
    this.authService = injector.get(AuthService);
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
}

@Directive({
  selector: "[svChannelVisibility]",
})
export class ChannelVisibilityDirective extends ChannelPermission {
  constructor(private injector: Injector) {
    super(injector);
  }

  @Input()
  set svChannelVisibility(permissions: number[]) {
    this.channelPermission =
      typeof permissions === "number" ? [permissions] : permissions || [];

    if (!permissions || permissions.length == 0) {
      this.viewContainerRef.clear();
      this.viewContainerRef.createEmbeddedView(this.templateRef);
      return;
    }

    this.updateView();

    // Get notified each time authentication state changes.
    this.authService.authUser$
      .pipe(takeUntil(this.destroyed$))
      .subscribe((_) => this.updateView());
  }

  private updateView(): void {
    this.authService
      .validateChannelPermission(this.channelPermission)
      .then((result) => {
        this.viewContainerRef.clear();
        if (result) {
          this.viewContainerRef.createEmbeddedView(this.templateRef);
        }
      });
  }
}

@Directive({
  selector: "[svChannelHidden]",
})
export class ChannelHiddenDirective extends ChannelPermission {
  channelPermission: number[] = [];

  constructor(private injector: Injector) {
    super(injector);
  }

  @Input()
  set svChannelHidden(permissions: number[]) {
    this.channelPermission =
      typeof permissions === "number" ? [permissions] : permissions || [];

    if (!permissions || permissions.length == 0) {
      this.viewContainerRef.clear();
      this.viewContainerRef.createEmbeddedView(this.templateRef);
      return;
    }

    this.updateView();

    // Get notified each time authentication state changes.
    this.authService.authUser$
      .pipe(takeUntil(this.destroyed$))
      .subscribe((_) => this.updateView());
  }

  private updateView(): void {
    this.authService
      .validateChannelPermission(this.channelPermission)
      .then((result) => {
        this.viewContainerRef.clear();
        if (!result) {
          this.viewContainerRef.createEmbeddedView(this.templateRef);
        }
      });
  }
}
